// src/components/PostForm.js
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { UpdateDiscussion } from '../../components/forms/update-discussion';


function UpdateForm() {
    const tags = [
        'Examinations', 
        'Nursing', 
        'Medical Imaging', 
        'Physiotherapy', 
        'Public Health', 
        'Pharmacy', 
        'Laboratory Science'
    ];

    const [chosenTags, setChosenTags] = useState([]);

    const post = useLocation().state?.post;

    useEffect(() => {
        setChosenTags(post.tags)
    },[post.tags.length])

    return (
        <div className='flx-c flx-v  post-form-pg'>
        <UpdateDiscussion
            tagsData={tags}
            checkTag={(v) => {
                chosenTags.includes(v) ?
                    setChosenTags((t) => t.filter((val) => val !== v)) :
                    setChosenTags((t) => ([...t, v]))
            }}
            checkedData={chosenTags}
        />
        </div>
    );
}

export default UpdateForm;